import BupiLink from "@/components/atoms/link";
import { SocialNav } from "@/components/molecules/SocialIcons";
import React from "react";

const FooterInfoSection = ({ socialLinks, footerLinks, copyrightText }: any) => {

  return (
    <div className="container mx-auto">
      <div className="grid items-center xs:grid-cols-4 md:grid-cols-8 xl:grid-cols-12 md:gap-x-32">
        <SocialNav socialMedias={socialLinks} />
        
        <div className="xs:col-span-4 md:col-span-8 xl:col-span-1 min-h-full min-w-full xl:relative">
          <div
            aria-hidden="true"
            className="border-1 border-white opacity-5 xl:h-[calc(100%-2px)] max-xl:w-full xl:bottom-0 xs:left-0 md:left-0 xl:left-1/2 absolute"
            role="separator"
          ></div>
        </div>

        <div className="xs:col-span-4 md:col-span-8 xl:col-span-7 xs:py-32 md:py-[44px]">
          <nav className="xs:col-span-4 md:col-span-8 xl:col-span-7" aria-label="Links do rodapé">
            <ul className="flex flex-wrap xs:flex-col md:flex-row xl:flex-row md:justify-center xl:justify-end xs:gap-x-32 md:gap-[30px]">
              {footerLinks.map((link: any, index: number) => (
                <li key={index} className="py-8">
                  <BupiLink
                    label={link.label}
                    url={link.href}
                    className="agora-anchor !font-normal agora-anchor-link-neutral inline-flex items-center justify-center min-h-[44px] min-w-[44px] py-8 dark-mode"
                    target={link.target}
                  />
                </li>
              ))}
            </ul>
          </nav>
          <div className="xs:col-span-4 md:col-span-8 xl:col-span-7 mt-32">
            <span className="text-s-regular text-white flex md:justify-center xl:justify-end">
              {copyrightText} - {new Date().getFullYear()}
            </span> 
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterInfoSection;
